import * as action_types from '../actions/action_types';

const initialState = {
  key: '',
  id: '',
  tableType: 'TableOfAlerts',
  data: [],
};

export const EnergyEfficiencyAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.SYNC_ENERGY_EFFICIENCY_MAP_WITH_TABLE:
      return Object.assign({}, state, {
        key: action.data.key,
        id: action.data.id,
        tableType: action.data.tableType,
      });
    case action_types.GET_PERFORMANCE_ALERTS:
      return Object.assign({}, state, {
        data: action.payload,
      });
    case action_types.GET_PERFORMANCE_TRACKERS:
      return Object.assign({}, state, {
        data: action.payload,
      });
    case action_types.GET_PERFORMANCE_ALERTS_CHIELD:
      return Object.assign({}, state, {
        data: action.payload,
      });
    case action_types.MOVE_TO_ARCHIVE:
      return Object.assign({}, state, {
        data: action.payload,
      });
    case action_types.MOVE_TO_HISTORIC:
      return Object.assign({}, state, {
        data: action.payload,
      });
    default:
      return state;
  }
};
